export const frontmatter = {
    "draft": true,
    "title": "Security and access",
    "sidebar_group": "reference",
    "sidebar_label": "Security and access",
    "sidebar_order": 1
}

export const toc = []